import React from 'react'


export const NotFoundComponent = () => {
    return <>
        <div>Página no encontrada</div>
    </>
}

